<template>
<div class="focused-panel">
  <div class="d-flex polytron-toolbar">
    <!--<div class="p-2">{{wellFeature ? wellFeature.get('ident') : 'No well selected'}}</div>-->
    <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Create polygon" :pressed.sync="addEnabled" variant="primary">
      <icon scale=".6" name="plus" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Select polygon" :pressed.sync="selectEnabled" variant="primary">
      <icon scale=".6" name="hand-pointer" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" :id="'undo-'+editorIdent" :disabled="!historyChanges" @click="undo" variant="primary">
      <icon scale=".6" name="undo" />
    </b-btn>
    <b-tooltip v-if="historyChanges" :target="'undo-'+editorIdent" placement="top">
      Undo
    </b-tooltip>


    <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit geometry" :disabled="!wellFeatureSelected" :pressed.sync="dragEnabled" variant="primary">
      <icon scale=".6" name="arrows-alt" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit attributes" :disabled="!wellFeatureSelected" :pressed.sync="editEnabled" variant="primary">
      <icon scale=".6" name="pencil-alt" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" @click="deleteFetaures" v-b-tooltip.hover.auto title="Delete poly" :disabled="!wellFeatureSelected" variant="primary">
      <icon scale=".6" name="times" />
    </b-btn>
  </div>

  <b-modal no-close-on-backdrop no-close-on-esc v-model="showForm" :title="formTitle" @ok="onOK" @cancel="onCancel">
    <div slot="modal-header">
      <label>{{formTitle}}</label>
    </div>
    <div class="p-2">
      <b-form>
        <b-row>
          <b-col>
            <b-form-group label="Name:">
              <b-form-input id="sequence_name" v-model="wellAttrs['name']" placeholder="Enter name"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Sequence:">
              <b-form-input id="sequence" type="range" v-model="wellAttrs['sequence_value']" placeholder="Enter sequence" min="1" max="20"></b-form-input>
              <div class="mt-2">Sequence value: {{ wellAttrs['sequence_value'] }}</div>
            </b-form-group>
          </b-col>
          <!-- <b-col>

            <b-form-group label="Cwp Name:">
              <b-form-input id="cwpname" v-model="wellAttrs['cwpname']" placeholder="Enter cwpname"></b-form-input>
            </b-form-group>
          </b-col> -->
        </b-row>
      </b-form>
    </div>
  </b-modal>

</div>
</template>

<script>
import 'vue-awesome/icons/arrows-alt'
import 'vue-awesome/icons/times'
import 'vue-awesome/icons/plus'
import 'vue-awesome/icons/save'
import 'vue-awesome/icons/check'
import Vue from 'vue'

import FeatureEditorMixin from '../../../mixins/FeatureEditorMixin'
import uuidV1 from 'uuid/v1'

export default {
  name: 'polytron',
  components: {

  },
  mixins: [FeatureEditorMixin],
  data() {
    return {
      markLastModified: false,
      featureId: null,
      addPolyEnabled: false,
      addLineEnabled: false,
      addPointEnabled: false,
      wellAttrs: {
        cwpname: null,
        // desc: '',
        batch_name: '',
        field_name: null,
        batch_online_year: null,
        // batch: null,
        sequence: null
      },
      options: [],
      causes: [],
      wellLayerName: 'v4:sequence_polygons',
      geometryName: 'geo',
      idName: 'id',
      geomType: 'Polygon',
      identName: 'name',
      gasDestOptions: [],
      gas_dest: 0
    }
  },
  methods: {


  },
}
</script>



// WEBPACK FOOTER //
// src/components/map/designotron/SequencePolygon.vue